module.exports = __webpack_public_path__ + "90247cfdde1bd7b76d804a797d5dec56.ttf";